/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type CountOrdersQueryVariables = Types.Exact<{
	filter: Types.CountOrdersFilter;
}>;

export type CountOrdersQuery = {
	__typename?: "Query";
	countOrders: {
		__typename?: "CountOrdersResponse";
		maxOpenOrders: number;
		closed: { __typename?: "CountOrderResponse"; buy: number; sell: number };
		done: { __typename?: "CountOrderResponse"; buy: number; sell: number };
		opened: { __typename?: "CountOrderResponse"; buy: number; sell: number };
		total: { __typename?: "CountOrderResponse"; buy: number; sell: number };
	};
};

export const CountOrdersDocument = gql`
	query countOrders($filter: CountOrdersFilter!) {
		countOrders(filter: $filter) {
			closed {
				buy
				sell
			}
			done {
				buy
				sell
			}
			opened {
				buy
				sell
			}
			total {
				buy
				sell
			}
			maxOpenOrders
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class CountOrdersGQLService extends Apollo.Query<CountOrdersQuery, CountOrdersQueryVariables> {
	document = CountOrdersDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
